export interface Job {
  id: number;
  title: string;
  description: string;
  location: string;
  pay: string;
  duration: string;
  requirements: string[];
  company: string;
  contact_email: string;
  created_at: string;
  is_active: boolean;
  category: string;
  link: string;
}

export const jobsData: Job[] = [
  // ACTIVE JOBS
  {
    id: 1,
    title: "Event Setup Assistant",
    description: "Help set up and organize a corporate event in Manhattan. Tasks include arranging tables, setting up AV equipment, and coordinating with vendors. Great opportunity to network with professionals.",
    location: "Manhattan, NY",
    pay: "$25/hour",
    duration: "4 hours",
    requirements: ["Physical fitness", "Attention to detail", "Reliability"],
    company: "Manhattan Events Co.",
    contact_email: "events@manhattanco.com",
    created_at: "2024-01-20T10:00:00Z",
    is_active: true,
    category: "Events",
    link: "https://forms.gle/event-setup-assistant-1"
  },
  {
    id: 2,
    title: "Food Delivery Driver",
    description: "Deliver food orders to customers in Brooklyn using your own vehicle. Flexible schedule, good tips, and immediate payment. Perfect for evening shifts!",
    location: "Brooklyn, NY",
    pay: "$18/hour + tips",
    duration: "6 hours",
    requirements: ["Valid driver's license", "Own vehicle", "Smartphone"],
    company: "Brooklyn Bites Delivery",
    contact_email: "jobs@brooklynbites.com",
    created_at: "2024-01-19T14:30:00Z",
    is_active: true,
    category: "Delivery",
    link: "https://forms.gle/food-delivery-driver-2"
  },
  {
    id: 3,
    title: "Social Media Content Creator",
    description: "Create engaging social media content for a trendy SoHo boutique. Must have experience with Instagram and TikTok. Flexible hours and creative freedom.",
    location: "SoHo, Manhattan",
    pay: "$35/hour",
    duration: "5 hours",
    requirements: ["Social media experience", "Creative skills", "Camera equipment"],
    company: "SoHo Style Boutique",
    contact_email: "creative@sohostyle.com",
    created_at: "2024-01-19T11:00:00Z",
    is_active: true,
    category: "Marketing",
    link: "https://forms.gle/social-media-creator-3"
  },
  {
    id: 4,
    title: "Personal Shopper Assistant",
    description: "Help busy professionals with grocery shopping and personal errands in Upper East Side. Must be organized and have good communication skills.",
    location: "Upper East Side, Manhattan",
    pay: "$22/hour",
    duration: "3 hours",
    requirements: ["Organizational skills", "Reliability", "Good communication"],
    company: "NYC Personal Services",
    contact_email: "shop@nycservices.com",
    created_at: "2024-01-18T16:20:00Z",
    is_active: true,
    category: "Personal Services",
    link: "https://forms.gle/personal-shopper-4"
  },
  {
    id: 5,
    title: "Warehouse Packer",
    description: "Pack and organize packages in a fast-paced warehouse environment in Queens. Great for building stamina and earning quick cash.",
    location: "Long Island City, Queens",
    pay: "$20/hour",
    duration: "8 hours",
    requirements: ["Physical fitness", "Attention to detail", "Team player"],
    company: "Queens Distribution Hub",
    contact_email: "pack@queenshub.com",
    created_at: "2024-01-18T09:45:00Z",
    is_active: true,
    category: "Warehouse",
    link: "https://forms.gle/warehouse-packer-5"
  },
  {
    id: 6,
    title: "Dog Walker & Pet Sitter",
    description: "Walk dogs and provide pet sitting services for busy professionals in Manhattan. Flexible schedule, love for animals required. Multiple clients available.",
    location: "Manhattan, NY",
    pay: "$20/hour",
    duration: "4 hours",
    requirements: ["Love for animals", "Reliability", "Physical fitness"],
    company: "Manhattan Pet Care",
    contact_email: "pets@manhattancare.com",
    created_at: "2024-01-17T13:00:00Z",
    is_active: true,
    category: "Pet Care",
    link: "https://forms.gle/dog-walker-6"
  },
  {
    id: 7,
    title: "Restaurant Server (Weekend)",
    description: "Serve customers at a busy restaurant in Williamsburg. Weekend shifts available, great tips, and fun atmosphere. Experience preferred but not required.",
    location: "Williamsburg, Brooklyn",
    pay: "$16/hour + tips",
    duration: "6 hours",
    requirements: ["Customer service", "Weekend availability", "Positive attitude"],
    company: "Williamsburg Eatery",
    contact_email: "serve@williamsburgeatery.com",
    created_at: "2024-01-17T10:30:00Z",
    is_active: true,
    category: "Restaurant",
    link: "https://forms.gle/restaurant-server-7"
  },
  {
    id: 8,
    title: "Moving Assistant",
    description: "Help families and individuals move apartments across NYC. Physical work but great pay and flexible scheduling. Truck and equipment provided.",
    location: "Various NYC",
    pay: "$25/hour",
    duration: "6 hours",
    requirements: ["Physical strength", "Reliability", "Problem-solving"],
    company: "NYC Quick Movers",
    contact_email: "move@nycmovers.com",
    created_at: "2024-01-16T15:15:00Z",
    is_active: true,
    category: "Moving",
    link: "https://forms.gle/moving-assistant-8"
  },
  {
    id: 9,
    title: "Freelance Photographer",
    description: "Photograph small events and gatherings in Manhattan. Must have own camera equipment and portfolio. Great for building your photography business.",
    location: "Manhattan, NY",
    pay: "$40/hour",
    duration: "3 hours",
    requirements: ["Photography portfolio", "Own equipment", "Professional demeanor"],
    company: "NYC Event Photography",
    contact_email: "photo@nyceventphoto.com",
    created_at: "2024-01-16T12:00:00Z",
    is_active: true,
    category: "Photography",
    link: "https://forms.gle/freelance-photographer-9"
  },
  {
    id: 10,
    title: "Uber/Lyft Driver Partner",
    description: "Drive for rideshare services during peak hours in NYC. Flexible schedule, immediate payments, and bonus opportunities during busy periods.",
    location: "NYC Wide",
    pay: "$22/hour + incentives",
    duration: "8 hours",
    requirements: ["Valid driver's license", "Clean driving record", "Own vehicle"],
    company: "Rideshare Partners NYC",
    contact_email: "drive@rideshare-nyc.com",
    created_at: "2024-01-15T14:45:00Z",
    is_active: true,
    category: "Transportation",
    link: "https://forms.gle/rideshare-driver-10"
  },

  // INACTIVE JOBS (EXPIRED/FILLED)
  {
    id: 11,
    title: "Construction Helper",
    description: "Assist with construction work in Brooklyn. Heavy lifting required. Safety equipment provided. Position has been filled.",
    location: "Brooklyn, NY",
    pay: "$28/hour",
    duration: "8 hours",
    requirements: ["Physical strength", "Safety awareness", "Reliability"],
    company: "Brooklyn Builders",
    contact_email: "build@brooklynbuilders.com",
    created_at: "2024-01-09T08:30:00Z",
    is_active: false,
    category: "Construction",
    link: "https://forms.gle/construction-helper-11"
  },
  {
    id: 12,
    title: "Catering Server",
    description: "Serve food and beverages at corporate events. Professional appearance required. Event has concluded.",
    location: "Queens, NY",
    pay: "$24/hour",
    duration: "6 hours",
    requirements: ["Professional appearance", "Customer service", "Reliability"],
    company: "Queens Catering Co.",
    contact_email: "serve@queenscatering.com",
    created_at: "2024-01-08T12:15:00Z",
    is_active: false,
    category: "Catering",
    link: "https://forms.gle/catering-server-12"
  },
  {
    id: 13,
    title: "Holiday Gift Wrapper",
    description: "Wrap gifts at a department store during holiday season. Position was seasonal and has ended.",
    location: "Midtown Manhattan",
    pay: "$18/hour",
    duration: "4 hours",
    requirements: ["Attention to detail", "Customer service", "Holiday availability"],
    company: "Midtown Department Store",
    contact_email: "wrap@midtownstore.com",
    created_at: "2023-12-20T09:00:00Z",
    is_active: false,
    category: "Retail",
    link: "https://forms.gle/gift-wrapper-13"
  },
  {
    id: 14,
    title: "Snow Removal Helper",
    description: "Help clear snow from sidewalks and driveways in Queens. Weather dependent work. Season has ended.",
    location: "Queens, NY",
    pay: "$20/hour",
    duration: "5 hours",
    requirements: ["Physical fitness", "Weather tolerance", "Early morning availability"],
    company: "Queens Snow Services",
    contact_email: "snow@queensservices.com",
    created_at: "2023-12-15T06:00:00Z",
    is_active: false,
    category: "Seasonal",
    link: "https://forms.gle/snow-removal-14"
  }
];

